module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1531-a896e6eeb93f5158ab1d97ee50f8cb3a.png";